import React, { Component } from "react"
import AOS from 'aos';
import Layout from "../components/layout"
import ContactTp from "../components/contactLayout"
import {Helmet} from 'react-helmet'
import Seo from "../components/seo"

class ContactPage extends Component {
  componentDidMount() {
    this.aos = AOS;
    this.aos.init();
  }    
  
  componentDidUpdate() {
    this.aos.refresh();
  }

   render () {
    return (
      <Layout>
      <Seo lang="en" />
        <Helmet>
          <title>Contact | SAHenry Portfolio</title>
          <meta name="description" content="Did you like what you saw in my portfolio? Contact me with enquiries about availability for development. I'd love to hear from you." />
          <link rel="canonical" href="https://sahenry.dev/contact/" />
          <meta property="og:locale" content="en_UK" />
          <meta property="og:type" content="article" />
          <meta property="og:title" content="Contact | SAHenry Portfolio" />
          <meta property="og:description" content="Did you like what you saw in my portfolio? Contact me with enquiries about availability for development. I'd love to hear from you." />
          <meta property="og:url" content="https://sahenry.dev/contact/" />
          <meta property="og:site_name" content="SAHenry Portfolio" />
          <meta property="og:image" content="/sahenry-portfolio_image_fbli.jpg" />
          <meta property="og:image:width" content="1200" />
          <meta property="og:image:height" content="630" />
          <meta property="og:image:alt" content="Contact" />
          <meta property="og:image:type" content="image/jpeg" />
          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:title" content="Contact | SAHenry Portfolio" />
          <meta name="twitter:description" content="Did you like what you saw in my portfolio? Contact me with enquiries about availability for development. I'd love to hear from you." />
          <meta name="twitter:image" content="/sahenry-portfolio_image_fbli.jpg" />
        </Helmet>
        <ContactTp></ContactTp>
      </Layout>
    )
   }
}

export default ContactPage
